import { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// Import UI Components
import { Icon, Tooltip } from '@geneui/components';
// Import Services
import { parseSanitizedHtml } from 'services/html';

const CJDescriptionInfoWrapper = ({ children, description }) => {
    const { t } = useTranslation();

    const descriptionHTML = t(description, { defaultValue: '' });

    if (!descriptionHTML) {
        return children;
    }

    const descriptionNode = parseSanitizedHtml(descriptionHTML);

    return (
        <div className="cms-cj-description-info-wrapper">
            {children}

            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            <Tooltip className="crm-text-from-html" text={descriptionNode as string}>
                <Icon type="bc-icon-info" />
            </Tooltip>
        </div>
    );
};

CJDescriptionInfoWrapper.propTypes = {
    description: PropTypes.string,
};

CJDescriptionInfoWrapper.defaultProps = {
    description: '',
};

export default memo(CJDescriptionInfoWrapper);
